<script setup>
import { onMounted } from "vue";

defineProps({
    title: String
});

onMounted(() => {
    // console.log(`the component is now mounted.`);
});
</script>


<template>
    <div class="vh-100">
        <main class="h-100">
            <slot></slot>
        </main>
    </div>
</template>
